import axios from 'axios'

export const blurEffectForm = axios.create({
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
    },
    baseURL: `https://blur-effect-api.herokuapp.com`,
    // baseURL: `http://192.168.20.31:3030`,
})
